import React from 'react';
import { Box, Container, Typography, Link, Paper, Divider } from '@mui/material';

const DeleteAccount = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Paper sx={{ p: { xs: 3, md: 5 } }}>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
          Account & Data Deletion Request
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Workflow.Estate ("Openly") accounts and data are managed by agencies. Account and agency-owned data
          deletion requests must be initiated by your <strong>agency administrator</strong>.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
            How to request deletion (agency-admin managed)
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Contact your <strong>agency administrator</strong> and ask them to submit a deletion request on your behalf.
            If you don’t know who your agency admin is, contact{' '}
            <Link href="mailto:support@workflow.estate">support@workflow.estate</Link> and we will help route the request.
          </Typography>
          <Box component="ul" sx={{ pl: 3, mb: 0 }}>
            <li>
              <Typography variant="body1" component="span">
                Your account email address
              </Typography>
            </li>
            <li>
              <Typography variant="body1" component="span">
                Your agency name (if known)
              </Typography>
            </li>
            <li>
              <Typography variant="body1" component="span">
                What you want deleted (account deletion and/or specific agency-owned data such as attendee/visitor records)
              </Typography>
            </li>
          </Box>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
            Verification
          </Typography>
          <Typography variant="body1">
            We may ask for additional information to verify the requester is authorized (e.g., agency admin role)
            before processing deletions.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
            Learn more
          </Typography>
          <Typography variant="body1">
            See our{' '}
            <Link href="/privacy" underline="hover">
              Privacy Policy
            </Link>{' '}
            for details about retention and your rights.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default DeleteAccount;


